export const projectsData = [
    {
        id: 1,
        projectName: '',
        projectDesc: '',
        tags: [],
        code: '',
        demo: '',
        image: ""
    },
 
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/